import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import Modal from 'react-bootstrap/Modal'
import { ErrorBoundary } from 'react-error-boundary';
import classNames from 'classnames';
import {
    Badge,
    Overlay,
    Button,
    Tooltip,
    OverlayTrigger,
    ButtonGroup,
    ButtonToolbar,
    ListGroup,
    ListGroupItem
} from 'react-bootstrap';

import ShareModal from "@graphistry/share-component";

import { ErrorFallback } from '../ErrorFallback';
import { KeplerModeButton } from './KeplerModeButton.tsx';
import styles from './styles.less';
import { createLogger } from '@graphistry/common/logger';
const logger = createLogger(__filename);

export const pageWidthThatToolbarShouldBeVertical = 387/*px*/;

export function ButtonList({ children, visible, menu = true }) {
    if (!visible || !menu) {
        return null;
    }

    return (
        <ListGroup className={styles['button-list']}>
            {children.map(child => [
                <ErrorBoundary
                    key={child.key}
                    FallbackComponent={ErrorFallback}
                    onError={(exn) => {
                        logger.error({exn}, 'Panel error');
                    }}
                    onReset={() => {
                        // reset the state of your app so the error doesn't happen again
                    }}
                >
                    <ListGroupItem
                        className={classNames({
                            [styles[child.key]]: true,
                            [styles['button-list-items-container']]: true
                        })}>
                        {child}
                    </ListGroupItem>
                </ErrorBoundary>,
                ' '
            ])}
        </ListGroup>
    );
}

export function ButtonListItems({ id, name, children }) {
    return (
        <ButtonToolbar
            data-group-name={name}
            className={classNames({
                [styles[id]]: true,
                [styles['button-list-items']]: true
            })}>
            <ButtonGroup vertical={id === 'camera'}>{children}</ButtonGroup>
        </ButtonToolbar>
    );
}

function ButtonListItemTooltip(name) {
    return <Tooltip id="button-list-item-tooltip">{name}</Tooltip>;
}

const timersById = { };

function withUnselectOnTimeout(handler) {
    return function (props) {

        const {timeoutMS, id, selected} = props;
        if ((timeoutMS === undefined) || (timeoutMS === 0)) {
            return handler(props);
        }

        const isTogglingOn = !selected;

        const disableTimeout = () => {
            try { clearTimeout(timersById[id]); } catch (e) {}
            try { delete timersById[id]; } catch (e) {}
        };

        const enableTimeout = () => {
            timersById[id] = setTimeout(
                (() => {
                    handler({...props, selected: !selected});
                    disableTimeout();
                }),
                timeoutMS);
        };

        disableTimeout();
        if (isTogglingOn) {
            enableTimeout();
        }

        return handler(props);

    };
}


function ShareModalFake(props) {

    const {show, setShow} = props;

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
  
    return (<Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
        <Modal.Title>Modal heading</Modal.Title>
        </Modal.Header>
        <Modal.Body>Woohoo, you're reading this text in a modal!</Modal.Body>
        <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
            Close
        </Button>
        <Button variant="primary" onClick={handleClose}>
            Save Changes
        </Button>
        </Modal.Footer>
    </Modal>);
}


export function ButtonListItem({
    flags,
    enabled,
    onItemSelected,
    renderPopover,
    popoverData,
    isPopoverOpen,
    groupId,
    badgeCount = 0,
    dataset,
    view,
    user,
    ...props
}) {
    const { id, name, type, selected } = props;

    if (groupId === 'view' && id === 'toggle-kepler-dropdown') {
        return <KeplerModeButton
            id={id}
            buttonLabel={props.buttonLabel}
            dropdownVisible={props.dropdownVisible}
            onItemSelected={onItemSelected}
            styles={styles}
        />;
    }

    let overlayRef, buttonWithOverlay;
    const isDisabled = enabled === false;
    const tooltipLabel = isDisabled
        ? (id === 'toggle-inspector' ? `${name} - Please wait, loading data...` : `${name} (N/A)`)
        : name;

    //trigger modal anchored here (vs. action->reducer->...)
    const [show, setShow] = useState(false);
    //const overlay = id === 'share-workbook' ? <ShareModalFake show={show} setShow={setShow} /> : null;
    const overlay = 
        id === 'share-workbook' && show
        ? <ShareModal
            key={'share-button-toolbar'}
            show={show}
            onHide={() => setShow(() => false)}
            csrftoken={(user||{}).csrfToken}
            isAuthenticated={!!(user||{}).isAuthenticated}
            isSharingEnabled={
                (user
                && user.entitlements
                && (
                       (user.entitlements.individual && user.entitlements.individual.is_active)
                       || (user.entitlements.team && user.entitlements.team.is_active)
                       || (user.entitlements.enterprise && user.entitlements.enterprise.is_active)
                       || (user.entitlements.GRAPHISTRY_CLOUD === false)))
                || !!flags.flag_share_modal}
            obj_id={dataset.id}
            objtype='dataset' /> 
        : null;
    const cb = id === 'share-workbook' ? () => { setShow(() => !show); } : () => {};
    if (id === 'share-workbook') {
        console.info({dataset, view, flags, user}, 'ShareModels ids');
    }

    const placement = groupId === 'camera' || (window && window.innerWidth < pageWidthThatToolbarShouldBeVertical) ? 'right' : 'bottom';

    const handleClick = (e) => {
        e.preventDefault() || (withUnselectOnTimeout(onItemSelected)(props));
        e.currentTarget.blur();
        cb(e);
    };

    if (type === undefined || !selected) {
        buttonWithOverlay = (<>
            <OverlayTrigger
                defaultOverlayShown={false}
                trigger={['hover', 'focus']}
                placement={placement}
                overlay={ButtonListItemTooltip(tooltipLabel)}>
                <Button
                    disabled={isDisabled}
                    id={id}
                    active={selected}
                    onClick={handleClick}
                    className={classNames({
                        [styles[id]]: true,
                        // fa: true,
                        'fa-fw': true,
                        [styles['selected']]: selected,
                        [styles['button-list-item']]: true
                    })}>
                    {(badgeCount && <Badge className='float-right'>{badgeCount}</Badge>) || undefined}
                    <span className={styles['overlay-hit-area']} ref={ref => (overlayRef = ref)} />
                </Button>
            </OverlayTrigger>
            { overlay }
        </>);
    } else {
        buttonWithOverlay = (
            <Button
                id={id}
                active={selected}
                onClick={handleClick}
                className={classNames({
                    [styles[id]]: true,
                    // fa: true,
                    'fa-fw': true,
                    [styles['selected']]: selected,
                    [styles['button-list-item']]: true
                })}>
                {(badgeCount && <Badge className='float-right'>{badgeCount}</Badge>) || undefined}
                <span className={styles['overlay-hit-area']} ref={ref => (overlayRef = ref)} />
                <Overlay
                    show={selected}
                    rootClose={true}
                    placement={placement}
                    containerPadding={10}
                    shouldUpdatePosition={true}
                    onHide={() => onItemSelected(props)}
                    target={() => ReactDOM.findDOMNode(overlayRef)}>
                    {renderPopover({ data: popoverData, isOpen: isPopoverOpen })}
                </Overlay>
                { overlay }
            </Button>
        );
    }

    return buttonWithOverlay;
}
